import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.members');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-members',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.members/view.scss */
:host {
  display: block;
  width: 100%;
  min-height: 100%;
  font-family: Pretendard, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

.member-directory-page {
  --member-ink: #242824;
  --member-muted: #737a73;
  --member-line: #dfe3dc;
  --member-canvas: #f4f5f1;
  --member-orange: #d85a36;
  min-height: 100vh;
  color: var(--member-ink);
  background: var(--member-canvas);
}

.member-directory-page *,
.member-directory-page *::before,
.member-directory-page *::after {
  box-sizing: border-box;
}

.member-directory-page button,
.member-directory-page input,
.member-directory-page select {
  font: inherit;
}

.member-directory-header {
  border-bottom: 0;
  background: #fafbf8;
}

.member-directory-page .member-directory-header.reviewops-unified-header {
  border-bottom: 0 !important;
}

.member-directory-header__inner {
  margin-inline: auto;
}

.member-directory-heading {
  display: grid;
  min-width: 0;
  gap: 7px;
}

.member-directory-eyebrow {
  display: none;
  width: fit-content;
  align-items: center;
  gap: 8px;
  color: var(--member-orange);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.15em;
}

.member-directory-eyebrow i {
  font-size: 12px;
}

.member-directory-heading h1 {
  margin: 0;
}

.member-directory-heading > p {
  margin: 0;
  color: #6d746d;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.45;
}

.member-directory-content {
  margin-inline: auto;
}

.member-directory-shell {
  border: 1px solid #dfe4da;
  background: #fff;
}

.member-directory-toolbar {
  position: relative;
  z-index: 2;
  background: #fff;
}

.member-directory-toolbar__top {
  border-bottom: 1px solid #eef0eb;
}

.member-directory-toolbar__heading {
  display: grid;
  min-width: 0;
  gap: 3px;
}

.member-directory-toolbar__heading > p {
  margin: 0;
  color: var(--member-orange);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.15em;
}

.member-directory-toolbar__heading > div {
  display: flex;
  align-items: center;
  gap: 10px;
}

.member-directory-toolbar__heading h2 {
  margin: 0;
  color: #282c28;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.025em;
}

.member-directory-toolbar__heading > div > span {
  display: inline-grid;
  min-width: 28px;
  height: 22px;
  padding: 0 8px;
  place-items: center;
  border-radius: 999px;
  color: #687068;
  background: #eff1ec;
  font-size: 12px;
  font-weight: 700;
}

.member-directory-toolbar__heading > small {
  color: #919690;
  font-size: 12px;
  font-weight: 600;
}

.member-directory-search,
.member-directory-sort {
  position: relative;
  display: flex;
  width: 100%;
  height: 42px;
  min-width: 0;
  align-items: center;
  margin: 0;
  border: 0;
  border-radius: 9px;
  background: #fbfbfa;
  box-shadow: inset 0 0 0 0.5px #cfd4cb;
  transition: box-shadow 0.18s ease, background 0.18s ease;
}

.member-directory-search:focus-within,
.member-directory-sort:focus-within {
  background: #fff;
  box-shadow: inset 0 0 0 0.5px #819283, 0 0 0 2px rgba(86, 112, 95, 0.1);
}

.member-directory-search > i,
.member-directory-sort > i:first-child {
  position: absolute;
  left: 14px;
  z-index: 1;
  color: #818881;
  font-size: 12px;
  pointer-events: none;
}

.member-directory-search input {
  width: 100%;
  height: 100%;
  color: #414641;
  box-shadow: none !important;
  font-size: 12px;
  font-weight: 700;
}

.member-directory-sort select {
  width: 100%;
  height: 100%;
  border: 0 !important;
  color: #414641;
  background: transparent !important;
  box-shadow: none !important;
  font-size: 12px;
  font-weight: 700;
}

.member-directory-search input {
  padding: 0 38px;
}

.member-directory-search button {
  position: absolute;
  right: 8px;
  display: grid;
  width: 26px;
  height: 26px;
  padding: 0;
  place-items: center;
  border: 0;
  color: #818781;
  background: #eff0ed;
  cursor: pointer;
}

.member-directory-sort select {
  padding: 0 36px;
  cursor: pointer;
  appearance: none;
}

.member-directory-sort > i:last-child {
  position: absolute;
  right: 13px;
  color: #7c837c;
  font-size: 12px;
  pointer-events: none;
}

.member-directory-toolbar__bottom {
  border-bottom: 1px solid var(--member-line);
  background: #fafbf8;
}

.member-role-tabs {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 5px;
}

.member-role-tabs button {
  display: inline-flex;
  min-height: 34px;
  align-items: center;
  gap: 7px;
  padding: 0 12px;
  border: 1px solid transparent;
  color: #777e77;
  background: transparent;
  cursor: pointer;
  transition: color 0.18s ease, border-color 0.18s ease, background 0.18s ease;
}

.member-role-tabs button:hover {
  color: #3f473f;
  background: #f0f2ed;
}

.member-role-tabs button.is-active {
  border-color: #d7dfd3;
  color: #354334;
  background: #edf2ea;
}

.member-role-tabs em {
  display: inline-grid;
  min-width: 19px;
  height: 19px;
  padding: 0 5px;
  place-items: center;
  border-radius: 999px;
  color: #7c827b;
  background: #e9ebe6;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.member-role-tabs button.is-active em {
  color: #fff;
  background: #60745b;
}

.member-directory-toolbar__note {
  display: inline-flex;
  justify-self: end;
  align-items: center;
  gap: 8px;
  color: #7a827a;
  font-size: 12px;
  font-weight: 700;
}

.member-directory-toolbar__note i {
  color: #657c67;
}

.member-directory-loading,
.member-directory-empty {
  display: grid;
  min-height: 320px;
  padding: 50px 24px;
  place-items: center;
  align-content: center;
  gap: 8px;
  color: #898f88;
  background: #fff;
  text-align: center;
}

.member-directory-loading {
  grid-auto-flow: column;
  gap: 10px;
  font-size: 12px;
}

.member-directory-empty > i {
  display: grid;
  width: 56px;
  height: 56px;
  margin-bottom: 4px;
  place-items: center;
  border: 1px solid #dfe3dc;
  border-radius: 16px;
  color: #6c7a69;
  background: #f2f5f0;
  font-size: 19px;
}

.member-directory-empty strong {
  color: #393e39;
  font-size: 13px;
  font-weight: 700;
}

.member-directory-empty p {
  max-width: 430px;
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.55;
}

.member-directory-empty button {
  display: inline-flex;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  margin-top: 7px;
  padding: 0 16px;
  border: 1px solid #d7ddd4;
  color: #4f5a4d;
  background: #fff;
  cursor: pointer;
}

.member-directory-table {
  width: 100%;
  min-width: 980px;
  table-layout: fixed;
  border-collapse: collapse;
}

.member-directory-table th {
  height: 43px;
  padding: 0 14px;
  border-bottom: 1px solid #e7eae4;
  color: #818780;
  background: #f7f8f6;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.025em;
  text-align: left;
}

.member-directory-table th:first-child,
.member-directory-table td:first-child {
  width: 27%;
  padding-left: 24px;
}

.member-directory-table th:nth-child(2) {
  width: 14%;
}

.member-directory-table th:nth-child(3) {
  width: 25%;
}

.member-directory-table th:nth-child(4) {
  width: 13%;
}

.member-directory-table th:nth-child(5) {
  width: 21%;
  padding-right: 24px;
  text-align: right;
}

.member-directory-row {
  height: 96px;
  background: #fff;
  transition: background 0.18s ease, box-shadow 0.18s ease;
  animation: memberRowIn 0.28s ease both;
}

.member-directory-row:hover {
  background: #fcfcf9;
  box-shadow: inset 3px 0 0 var(--member-orange);
}

.member-directory-row td {
  padding: 14px;
  border-bottom: 1px solid #eef0eb;
  color: #424842;
  font-size: 12px;
  font-weight: 700;
  vertical-align: middle;
}

.member-directory-row:last-child td {
  border-bottom: 0;
}

.member-directory-row td:last-child {
  padding-right: 24px;
}

.member-directory-identity {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 12px;
}

.member-directory-identity > span {
  display: grid;
  width: 42px;
  height: 42px;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 11px;
  color: #4c6552;
  background: #edf3eb;
  font-size: 12px;
  font-weight: 700;
}

.member-directory-identity > div {
  display: grid;
  min-width: 0;
  gap: 4px;
}

.member-directory-identity strong {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 7px;
  color: #303530;
  font-size: 12px;
  font-weight: 700;
}

.member-directory-identity strong em {
  flex: 0 0 auto;
  padding: 3px 6px;
  border-radius: 5px;
  color: #787f78;
  background: #eff1ed;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.member-directory-identity small {
  overflow-wrap: anywhere;
  color: #8a908a;
  font-size: 12px;
  font-weight: 600;
  white-space: normal;
}

.member-role-badge {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  gap: 6px;
  padding: 0 9px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}

.member-role-badge.is-admin {
  color: #555c91;
  background: #eff0ff;
}

.member-role-badge.is-reviewer {
  color: #416e58;
  background: #eaf5ee;
}

.member-role-scope {
  display: grid;
  gap: 4px;
}

.member-role-scope strong {
  color: #4a504a;
  font-size: 12px;
  font-weight: 700;
}

.member-role-scope small {
  color: #929892;
  font-size: 12px;
  font-weight: 600;
}

.member-directory-row time {
  color: #737a73;
  font-size: 12px;
  font-weight: 700;
}

.member-role-switch {
  display: flex;
  width: fit-content;
  align-items: center;
  margin-left: auto;
  padding: 3px;
  border: 1px solid #e3e5e0;
  border-radius: 9px;
  background: #f1f2ef;
}

.member-role-switch button {
  display: inline-flex;
  min-width: 76px;
  min-height: 32px;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 0 11px;
  border: 0;
  color: #929792;
  background: transparent;
  cursor: pointer;
  transition: color 0.18s ease, background 0.18s ease, box-shadow 0.18s ease;
}

.member-role-switch button.is-active {
  color: #3d5f4b;
  background: #fff;
  box-shadow: 0 1px 4px rgba(39, 46, 39, 0.09);
}

.member-role-switch button:last-child.is-active {
  color: #555c91;
}

.member-role-switch button:disabled {
  cursor: wait;
  opacity: 0.58;
}

.member-directory-footer {
  border-top: 0;
  color: #858b84;
  background: #fafbf8;
}

.member-directory-footer nav {
  display: flex;
  grid-column: 2;
  gap: 5px;
}

.member-directory-footer__page-size {
  grid-column: 3;
  justify-self: end;
  white-space: nowrap;
}

.member-directory-footer button {
  display: grid;
  width: 30px;
  height: 30px;
  padding: 0;
  place-items: center;
  border: 1px solid #dfe3dc;
  color: #747b74;
  background: #fff;
  cursor: pointer;
}

.member-directory-footer button.is-active {
  border-color: var(--member-orange);
  color: #d25231;
  background: #fff7f3;
}

.member-directory-footer button:disabled {
  color: #c7cbc5;
  background: #f4f5f2;
  cursor: not-allowed;
}

.member-directory-page button:focus-visible,
.member-directory-page select:focus-visible {
  outline: 2px solid #69806d;
  outline-offset: 2px;
}

@keyframes memberRowIn {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 1020px) {
  .member-directory-toolbar__note {
    justify-self: start;
  }
  .member-directory-mobile {
    background: #f6f8f4;
  }
  .member-directory-mobile article {
    display: grid;
    gap: 14px;
    padding: 18px;
    border: 1px solid #dfe3dc;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 4px 16px rgba(31, 38, 31, 0.035);
  }
  .member-directory-mobile article > header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }
  .member-directory-mobile article dl {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin: 0;
    overflow: hidden;
    border: 1px solid #e4e7e1;
    border-radius: 9px;
  }
  .member-directory-mobile article dl > div {
    display: grid;
    min-height: 60px;
    padding: 10px 12px;
    align-content: center;
    gap: 4px;
    border-right: 1px solid #e4e7e1;
  }
  .member-directory-mobile article dl > div:last-child {
    border-right: 0;
  }
  .member-directory-mobile dt {
    color: #999e98;
    font-size: 12px;
    font-weight: 700;
  }
  .member-directory-mobile dd {
    margin: 0;
    color: #3e433e;
    font-size: 12px;
    font-weight: 700;
  }
  .member-directory-mobile .member-role-switch {
    width: 100%;
  }
  .member-directory-mobile .member-role-switch button {
    flex: 1;
  }
}
@media (max-width: 720px) {
  .member-role-tabs {
    width: 100%;
    overflow-x: auto;
  }
  .member-directory-toolbar__note {
    align-items: flex-start;
    line-height: 1.45;
  }
  .member-directory-footer nav {
    justify-self: end;
  }
  .member-directory-footer__page-size {
    display: none;
  }
}
@media (prefers-reduced-motion: reduce) {
  .member-directory-row,
  .member-role-switch button {
    animation: none;
    transition: none;
  }
}
:host-context(.reviewops-shell) .member-directory-page .member-directory-sort {
  flex: 0 1 156px;
  width: auto;
  height: auto;
  min-height: 44px;
  border: 1px solid var(--ro-control);
  background: var(--ro-surface);
  box-shadow: none;
}
:host-context(.reviewops-shell) .member-directory-page .member-directory-sort > i {
  display: none;
}
:host-context(.reviewops-shell) .member-directory-page .member-directory-sort select {
  height: auto;
  padding: 9px 12px !important;
  appearance: auto;
}
:host-context(.reviewops-shell) .member-directory-page .member-directory-identity strong {
  flex-wrap: wrap;
}

/* 19G LIST-RADIUS-001: use the 11px inner edge of the shared 12px list frame. */
:host-context(.reviewops-shell) .member-directory-page .member-directory-toolbar,
:host-context(.reviewops-shell) .member-directory-page .member-directory-toolbar__top {
  border-radius: 11px 11px 0 0 !important;
}
:host-context(.reviewops-shell) .member-directory-page .member-directory-toolbar__bottom {
  border-bottom-color: var(--ro-line);
}
:host-context(.reviewops-shell) .member-directory-page .member-directory-footer {
  border-top: 1px solid var(--ro-line);
  border-radius: 0 0 11px 11px;
}`],
})
export class PageMembersComponent implements OnInit {
    public loading: boolean = false;
    public members: any[] = [];
    public search: any = { text: '', role: '' };
    public roles: string[] = ['admin', 'reviewer'];
    public updatingUserId: string = '';
    public sortMode: string = '최근 가입 순';
    public sortOptions: string[] = ['최근 가입 순', '이름 가나다 순', '역할별 보기'];
    public currentPage: number = 1;
    public readonly pageSize: number = 10;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.role('admin', '/access');
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call('list', {});
        if (code === 200) {
            this.members = Array.isArray(data) ? data : [];
        } else {
            await this.service.modal.error(data?.message || '사용자 목록을 불러오지 못했습니다.');
        }

        this.loading = false;
        await this.service.render();
    }

    public async filterByRole(role: string) {
        this.search.role = role;
        this.resetPage();
        await this.service.render();
    }

    public async submitSearch(event?: Event) {
        event?.preventDefault();
        this.resetPage();
        await this.service.render();
    }

    public clearSearch(searchInput?: HTMLInputElement) {
        if (searchInput?.isConnected && !searchInput.disabled) searchInput.focus({preventScroll: true});
        this.search.text = '';
        this.resetPage();
    }

    public resetFilters() {
        this.search = { text: '', role: '' };
        this.sortMode = '최근 가입 순';
        this.resetPage();
    }

    public resetPage() {
        this.currentPage = 1;
    }

    public filteredMembers() {
        const query = String(this.search.text || '').trim().toLowerCase();
        const rows = this.members.filter((member: any) => {
            const roleMatch = !this.search.role || member.role === this.search.role;
            const queryMatch = !query
                || String(member.name || '').toLowerCase().includes(query)
                || String(member.email || '').toLowerCase().includes(query);
            return roleMatch && queryMatch;
        });
        return rows.sort((left: any, right: any) => {
            if (this.sortMode === '이름 가나다 순') {
                return String(left.name || '').localeCompare(String(right.name || ''), 'ko');
            }
            if (this.sortMode === '역할별 보기') {
                const roleOrder = Number(right.role === 'admin') - Number(left.role === 'admin');
                return roleOrder || String(left.name || '').localeCompare(String(right.name || ''), 'ko');
            }
            return String(right.joined || '').localeCompare(String(left.joined || ''))
                || String(left.name || '').localeCompare(String(right.name || ''), 'ko');
        });
    }

    public pagedMembers() {
        const start = (this.currentPage - 1) * this.pageSize;
        return this.filteredMembers().slice(start, start + this.pageSize);
    }

    public totalPages() {
        return Math.max(1, Math.ceil(this.filteredMembers().length / this.pageSize));
    }

    public pageNumbers() {
        return Array.from({ length: this.totalPages() }, (_, index) => index + 1);
    }

    public goToPage(page: number) {
        this.currentPage = Math.min(Math.max(1, page), this.totalPages());
    }

    public roleLabel(role: string) {
        return role === 'admin' ? '관리자' : '검수자';
    }

    public roleDescription(role: string) {
        return role === 'admin'
            ? '전체 운영 및 사용자 관리 권한'
            : 'QA·KG 검수 작업 전용 권한';
    }

    public roleCount(role: string) {
        return this.members.filter((member: any) => member.role === role).length;
    }

    public isCurrentUser(member: any) {
        return String(member?.id || '') === String(this.service.auth.session?.id || '');
    }

    public async changeRole(member: any, role: 'admin' | 'reviewer') {
        if (!member?.id || member.role === role || this.updatingUserId) return;

        const confirmed = await this.service.modal.show({
            title: '사용자 역할 변경',
            message: `${member.name}님의 역할을 ${this.roleLabel(role)}로 변경할까요?`,
            action: '변경',
            actionBtn: 'primary',
            status: 'info'
        });
        if (!confirmed) return;

        this.updatingUserId = member.id;
        await this.service.render();
        const { code, data } = await wiz.call('update_role', { id: member.id, role });

        if (code === 200) {
            member.role = role;
            await this.service.modal.success(`${member.name}님의 역할을 ${this.roleLabel(role)}로 변경했습니다.`);
            if (data?.current_user) {
                location.href = role === 'admin' ? '/dashboard' : '/human-reviews';
                return;
            }
        } else {
            await this.service.modal.error(data?.message || '역할을 변경하지 못했습니다.');
        }

        this.updatingUserId = '';
        await this.service.render();
    }
}

export default PageMembersComponent;